<template>

    <div class="contact-page admin-page">
        <Header></Header>
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <router-link class="next-icon add-btn" :to="`/admin/press/`"><img src="@/assets/img/prev.svg"/> Press List</router-link>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Press Edit</h2>
                        <form class="form" v-on:submit="pressFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Title" v-model="title" id="your-title">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-location">Author Name *</label>
                                <input type="text" placeholder="Author" v-model="author" id="your-location">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Image *</p>
                                <label for="image">
                                    <span>{{imageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="image" ref="file" v-on:change="handleImageFileUpload">
                            </div>
                            <div class="input-field form-input">
                                <label for="your-email">Date *</label>
                                <datepicker placeholder="date" v-model="date" id="your-email" format="MMMM d yyyy"></datepicker>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label>Message *</label>
                                <ckeditor type="classic" v-model="message"></ckeditor>
                            </div>

                            <div class="input-submit">
                                <button type="submit" v-if="!submitFlag">SUBMIT</button>
                                <span v-if="submitFlag">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>


<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import axios from 'axios'
    import Vue from 'vue'
    import router from '../../../router'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)
    import Datepicker from 'vuejs-datepicker'

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
    import VueCkeditor from 'vue-ckeditor5'

    const options = {
        editors: {
            classic: ClassicEditor
        },
        name: 'ckeditor'
    }

    Vue.use(VueCkeditor.plugin, options)

    export default {
        name: 'EventEdit',
        components: {
            'Header': Header,
            'Footer': Footer,
            'Datepicker': Datepicker
        },
        mounted () {
            axios
                .get('/pressById', {
                    params: {
                        eventId: this.eventId
                    }
                })
                .then(response => {
                    console.log(response)
                    this.title = response.data.title
                    this.date = response.data.date
                    this.message = response.data.message
                    this.author = response.data.author
                    this.imageName = response.data.images[0].bgImageName
                    this.imageId = response.data.images[0]._id
                })
                .catch(error => console.log(error))
        },
        data() {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                title: '',
                date: '',
                message: '',
                author: '',
                image: '',
                imageName: '',
                imageId: '',
                userData: userdata,
                submitFlag: false,
                eventId: router.history.current.params.id
            }
        },
        methods: {
            handleImageFileUpload(){
                this.image = this.$refs.file.files[0]
                this.imageName = this.$refs.file.files[0].name
            },
            pressFormSubmit: function (event) {
                event.preventDefault()
                this.submitFlag = true
                if(this.image){
                    const formData = new FormData()
                    formData.append('image', this.image)
                    formData.append('imageName', this.imageName)
                    formData.append('imageId', this.imageId)
                    try {
                        axios.post('/eventImageEdit', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.pressUpdate(this)
                            console.log(res)
                        }).catch(err => {
                            this.submitFlag = false
                            console.log(err)
                        })
                    } catch (e) {
                        this.submitFlag = false
                        console.log(e)
                    }
                } else {
                    this.pressUpdate(this)
                }
            },
            pressUpdate: function (event) {
                axios.post('/editPress', {
                    title: this.title,
                    date: this.date,
                    message: this.message,
                    author: this.author,
                    eventId: this.eventId
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(function (response) {
                    // console.log(this.submitFlag)
                    event.submitFlag = false

                    Vue.$toast.open(
                        {
                            message: 'Form submitted successfully!',
                            type: 'success',
                            position: 'top-right'
                        }
                    )
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/press/Edit.vue